import React from 'react';
import { ReactComponent as JavaScriptSVG } from '../../assets/svg/JavaScript.svg';

const JavaScriptIcon = ({ color = 'rgb(230,230,230)', size = 25, className = 'JavaScript-icon' }) => {
  return (
    <JavaScriptSVG
      className={className}
      style={{  }}
    />
  );
};

export default JavaScriptIcon;